import { render, staticRenderFns } from "./PlanFrame.vue?vue&type=template&id=a56fdd34&scoped=true"
import script from "./PlanFrame.vue?vue&type=script&lang=js"
export * from "./PlanFrame.vue?vue&type=script&lang=js"
import style0 from "./PlanFrame.vue?vue&type=style&index=0&id=a56fdd34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56fdd34",
  null
  
)

export default component.exports